import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/immobilier";
export default function SecteurImmobilier() { return <SectorLayout data={data} />; }
